import { useFormContext } from 'react-hook-form';
import { ReactNode } from 'react';

export const IsAddressSameAsPrimaryFieldWatcher = ({
    children,
}: {
    children: (state: boolean) => ReactNode;
}) => {
    const { watch } = useFormContext();
    const isAddressSameAsPrimary = watch('coApplicant.isAddressSameAsPrimary');

    return children(isAddressSameAsPrimary as boolean);
};
